import { useEffect, useState } from "react"


export const PaymentsType = ({ dataString }) => {

    const [paymentsType, setPaymentsType] = useState()
    useEffect(() => {
        const dataJson = JSON.parse(dataString)
        console.log(dataJson)
        setPaymentsType(dataJson)
    }, [dataString])

    return (
        <>
            {paymentsType &&
                paymentsType.map(payment =>
                    <div key={payment.type}>
                        <div>
                            <span className="text-success">
                                {payment.type === "card" && "Банковской картой"}
                                {payment.type === "cash" && "Наличными"}
                            </span>
                        </div>
                        {payment.sum} ₽
                    </div>
                )
            }
        </>
    )
}